<template>
  <v-dialog
    :value="true"
    width="95%"
    persistent
    scrollable
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <v-card>
      <v-card-title class="text-h3 primary--text"
        >PROCESAR MUESTRAS - PRUEBAS RÁPIDAS</v-card-title
      >
      <v-card-text>
        <v-form ref="formRapidas">
          <v-layout row wrap>
            <v-flex xs12>
              <v-simple-table fixed-header height="500px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left primary--text">
                        Código
                      </th>
                      <th class="text-left primary--text">
                        Fecha Toma
                      </th>
                      <th class="text-left primary--text">
                        Tipo Análisis
                      </th>
                      <th class="text-left primary--text">
                        Control
                      </th>
                      <th class="text-left primary--text">
                        Test / IgM
                      </th>
                      <th class="text-left primary--text">
                        IgG
                      </th>
                      <th width="25%" class="text-left primary--text">
                        Interpretación
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody v-if="muestras.length === 0">
                    <td colspan="3">
                      <div class="ma-3">
                        Por favor lea las muestras a cargar ...
                      </div>
                    </td>
                  </tbody>
                  <tbody>
                    <tr v-for="m in muestras" :key="m.Codigo">
                      <td>{{ m.Codigo }}</td>
                      <td>
                        {{
                          m.FechaMuestra
                            ? fechaSQL(m.FechaMuestra) +
                              " " +
                              horaSQL(m.FechaMuestra)
                            : "-"
                        }}
                      </td>
                      <td>{{ m.AnalisisTipo }}</td>
                      <td>
                        <v-radio-group
                          @change="actualizarInterpretacion(m)"
                          row
                          :rules="[
                            () => m.Control != null || 'Campo requerido',
                          ]"
                          v-model="m.Control"
                        >
                          <v-radio label="Positivo" :value="true"></v-radio>
                          <v-radio label="Negativo" :value="false"></v-radio>
                        </v-radio-group>
                      </td>
                      <td>
                        <v-radio-group
                          @change="actualizarInterpretacion(m)"
                          row
                          :rules="[
                            () => m.Test_IgM != null || 'Campo requerido',
                          ]"
                          v-model="m.Test_IgM"
                        >
                          <v-radio label="Positivo" :value="true"></v-radio>
                          <v-radio label="Negativo" :value="false"></v-radio>
                        </v-radio-group>
                      </td>
                      <td>
                        <v-radio-group
                          @change="actualizarInterpretacion(m)"
                          v-if="m.AnalisisTipoID === 2"
                          row
                          :rules="[() => m.IgG != null || 'Campo requerido']"
                          v-model="m.IgG"
                        >
                          <v-radio label="Positivo" :value="true"></v-radio>
                          <v-radio label="Negativo" :value="false"></v-radio>
                        </v-radio-group>
                      </td>
                      <td width="25%">
                        {{ m.Interpretacion }}
                      </td>
                      <td>
                        <v-btn
                          v-if="m.Imagen"
                          @click.prevent="verImagen(m.Imagen)"
                          icon
                          color="primary"
                        >
                          <v-icon>image</v-icon>
                        </v-btn>
                        <v-btn
                          @click.prevent="borrarMuestra(m)"
                          icon
                          color="error"
                        >
                          <v-icon>close</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
        </v-form>
        <lector-codigos
          :desactivado="mostrarLecturaManual"
          @codigoLeido="leer"
        ></lector-codigos>

        <codigo-manual
          v-if="mostrarLecturaManual"
          @cerrar="cerrarCodigoManual"
        ></codigo-manual>
      </v-card-text>
      <v-card-actions>
        <v-btn class="mr-5" text @click.prevent="cerrar(false)">
          Cancelar</v-btn
        >
        <v-spacer> </v-spacer>
        <v-btn class="mr-5" text @click.prevent="lecturaManual"
          ><v-icon>add</v-icon> Lectura Manual</v-btn
        >
        <v-btn v-if="!!muestras.length" color="primary" @click.prevent="guardar"
          ><v-icon>save</v-icon> Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CodigoManual from "../../components/CodigoManual.vue";
import LectorCodigos from "../../components/LectorCodigos.vue";
import ServicioLaboratorio from "../../services/laboratorio";
export default {
  components: { LectorCodigos, CodigoManual },
  name: "pruebasRapidas",
  props: ["codigoBarras"],
  data() {
    return {
      muestras: [],
      mostrarLecturaManual: false,
    };
  },
  mounted() {
    if (!!this.codigoBarras) {
      this.leer(this.codigoBarras);
    }
  },
  methods: {
    async actualizarInterpretacion(muestra) {
      if (
        muestra.Control != null &&
        muestra.Test_IgM != null &&
        (muestra.AnalisisTipoID == 3 || muestra.IgG != null)
      ) {
        const res = await ServicioLaboratorio.getInterpretacion(muestra);
        if (res.data.result === 1) {
          muestra.Interpretacion = res.data.data.Table0[0].Interpretacion;
        } else {
          this.$root.mensajeError = res.data.mensaje;
        }
      }
    },
    cerrarCodigoManual(codigo) {
      if (codigo) {
        this.leer(codigo);
      }
      this.mostrarLecturaManual = false;
    },
    lecturaManual() {
      this.mostrarLecturaManual = true;
    },
    async leer(codigo) {
      if (this.muestras.some((m) => m.Codigo === codigo)) {
        return (this.$root.mensajeError =
          "La muestra ya se encuentra en la lista.");
      }
      const res = await ServicioLaboratorio.rapidasCodigo(codigo);
      if (res.data.result === 1) {
        this.muestras.push({ Codigo: codigo, ...res.data.data.Table0[0] });
      } else {
        this.$root.mensajeError = res.data.message;
      }
    },
    async guardar() {
      if (!this.$refs.formRapidas.validate()) {
        this.$root.mensajeError = "Por favor llene todos los campos requeridos";
        return;
      }
      const muestras = this.muestras.map((m) => {
        return {
          MuestraDetalleID: m.MuestraDetalleID,
          Control: m.Control,
          Test_IgM: m.Test_IgM,
          IgG: m.IgG,
        };
      });
      const res = await ServicioLaboratorio.rapidasResultado(muestras);
      if (res.data.result === 1) {
        this.$root.mensajeExito = "El proceso se realizó con éxito";
        this.cerrar(true);
      } else {
        this.$root.mensajeError =
          res.data.message || "Error al guardar el resultado";
      }
    },
    cerrar(cambios = false) {
      this.$emit("cerrar", cambios);
    },
    borrarMuestra(m) {
      const ix = this.muestras.indexOf(m);
      this.muestras.splice(ix, 1);
    },
  },
};
</script>
